import React from 'react';
import FlowLayout from '~/client/components/flow-layout/flow-layout';
import PaymentV2 from '~/client/components/payment-v2/payment-v2';
import type { RenewPay as Props } from './renew-pay.types';

const RenewPay: React.FC<Props> = ({ layout, payment }) => (
  <FlowLayout {...layout}>
    <div className="renew-pay">
      <PaymentV2 {...payment} />
    </div>
  </FlowLayout>
);

export default RenewPay;
